import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type TenantPlanViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  name_esValue?: { displayId: string; id: string } | null;
  name_es: string;
  name_enValue?: { displayId: string; id: string } | null;
  name_en: string;
  name_ptValue?: { displayId: string; id: string } | null;
  name_pt: string;
  description_esValue?: { displayId: string; id: string } | null;
  description_es: string;
  description_enValue?: { displayId: string; id: string } | null;
  description_en: string;
  description_ptValue?: { displayId: string; id: string } | null;
  description_pt: string;
  limitsValue?: { displayId: string; id: string } | null;
  limits: string;
};

export const TenantPlanViewForm: React.FC<TenantPlanViewFormProps> = observer(
  ({
    onPrint = () => {},
    onCancel = () => {},
    onEdit,
    showToolbox = true,
    name_es = "",
    name_en = "",
    name_pt = "",
    description_es = "",
    description_en = "",
    description_pt = "",
    limits = "{}",
  }) => {
    const rootStore = useRootStore();
    const { langStore } = rootStore;

    const componentRef = useRef(null);
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });

    return (
      <Grid>
        {showToolbox && (
          <FormToolbox
            editForm={onEdit}
            printForm={() => onPrint(handlePrint)}
            closeForm={() => onCancel()}
          />
        )}
        <Box ref={componentRef}>
          <GroupContainer
            id="null"
            title={langStore.groupTenantPlanLabel}
            collapsible={false}
          >
            <FormControl fullWidth>
              <ShowMultiLine
                value={name_es}
                label={langStore.TenantPlanNameLabel + " (es)"}
              />
              ,
              <ShowMultiLine
                value={name_en}
                label={langStore.TenantPlanNameLabel + " (en)"}
              />
              ,
              <ShowMultiLine
                value={name_pt}
                label={langStore.TenantPlanNameLabel + " (pt)"}
              />
              <ShowMultiLine
                value={description_es}
                label={langStore.TenantPlanDescriptionLabel + " (es)"}
              />
              ,
              <ShowMultiLine
                value={description_en}
                label={langStore.TenantPlanDescriptionLabel + " (en)"}
              />
              ,
              <ShowMultiLine
                value={description_pt}
                label={langStore.TenantPlanDescriptionLabel + " (pt)"}
              />
              <ShowMultiLine
                value={limits}
                label={langStore.TenantPlanLimitsLabel}
              />
            </FormControl>
          </GroupContainer>
        </Box>
      </Grid>
    );
  }
);
